import {
  ImageScaleView,
  View,
  ViewOpts,
  animate,
} from '@play-co/timestep-core/ui';
import { magicLampsAnim } from './MagicLampsAnim';
import { engine } from '@play-co/timestep-core';

interface MagicLampsRaysOpts extends ViewOpts {
  radius?: number;
}

export class MagicLampsRays extends View {
  private image1: ImageScaleView;
  private image2: ImageScaleView;

  constructor(opts: MagicLampsRaysOpts) {
    super({
      width: 600,
      height: 600,
      visible: false,
      centerOnOrigin: true,
      ...opts,
    });

    const radius = opts.radius || this.style.width * 0.5;

    this.image1 = new ImageScaleView({
      superview: this,
      image: 'assets/ui/match2/magiclamps/magiclamps_rays.png',
      scaleMethod: 'contain',
      width: radius * 2,
      height: radius * 2,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      centerOnOrigin: true,
      opacity: 0.5,
    });

    this.image2 = new ImageScaleView({
      superview: this,
      image: 'assets/ui/match2/magiclamps/magiclamps_rays.png',
      scaleMethod: 'contain',
      width: radius * 2,
      height: radius * 2,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      centerOnOrigin: true,
      opacity: 0.5,
    });
  }

  public async showAnimated() {
    this.show();
    engine.subscribe('Tick', this.tickHandler);
    this.updateOpts({ scale: 0 });
    await magicLampsAnim(this, { scale: 1 }, 300, animate.easeOut);
  }

  public async hideAnimated() {
    await magicLampsAnim(this, { scale: 0 }, 200, animate.easeIn);
    engine.unsubscribe('Tick', this.tickHandler);
    this.hide();
  }

  private tickHandler = () => {
    this.image1.style.r += 0.02;
    this.image2.style.r -= 0.01;
  };
}
